import React from "react";

// Very light abstract hero backdrop: grey gradients, flowing waves, node network, faint architectural silhouettes.
export default function HeroBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="hero-backdrop">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_85%_20%,#eef1f5_0%,transparent_70%),radial-gradient(ellipse_50%_50%_at_10%_90%,#f3f4f6_0%,transparent_70%)]" />
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 720" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="hb-wave" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="#cbd5e1" stopOpacity="0" />
            <stop offset="0.5" stopColor="#94a3b8" stopOpacity="0.35" />
            <stop offset="1" stopColor="#cbd5e1" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="hb-arch" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0" stopColor="#94a3b8" stopOpacity="0.10" />
            <stop offset="1" stopColor="#94a3b8" stopOpacity="0" />
          </linearGradient>
          <pattern id="hb-grid" width="48" height="48" patternUnits="userSpaceOnUse">
            <path d="M48 0H0V48" fill="none" stroke="#cbd5e1" strokeOpacity="0.28" strokeWidth="0.6" />
          </pattern>
          <radialGradient id="hb-fade" cx="0.78" cy="0.42" r="0.62">
            <stop offset="0" stopColor="#fff" stopOpacity="1" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </radialGradient>
          <mask id="hb-mask"><rect width="1440" height="720" fill="url(#hb-fade)" /></mask>
        </defs>

        <rect width="1440" height="720" fill="url(#hb-grid)" mask="url(#hb-mask)" />

        <g fill="url(#hb-arch)" className="hb-drift">
          {[[780, 560, 60], [850, 470, 46], [906, 400, 70], [986, 500, 40], [1036, 430, 58], [1104, 350, 34], [1148, 460, 64], [1222, 520, 44], [1276, 410, 52], [1338, 490, 70]]
            .map(([x, y, w], i) => <rect key={i} x={x} y={y} width={w} height={720 - y} rx="2" />)}
          <path d="M1190 720V600a36 36 0 0 1 72 0v120z" />
        </g>

        <g fill="none" strokeLinecap="round" className="hb-wave">
          <path d="M-40 520C220 440 420 600 720 520S1220 420 1480 500" stroke="url(#hb-wave)" strokeWidth="1.4" />
          <path d="M-40 560C260 480 460 640 760 560S1240 470 1480 545" stroke="url(#hb-wave)" strokeWidth="1" />
          <path d="M-40 600C300 530 500 680 800 600S1260 520 1480 590" stroke="url(#hb-wave)" strokeWidth="0.8" />
        </g>

        <g stroke="#94a3b8" strokeOpacity="0.22" strokeWidth="0.7" fill="#94a3b8" fillOpacity="0.35">
          {[[980, 150, 1080, 210], [1080, 210, 1200, 170], [1200, 170, 1290, 250], [1080, 210, 1130, 300], [1130, 300, 1290, 250], [1290, 250, 1370, 190]]
            .map(([a, b, c, d], i) => <line key={i} x1={a} y1={b} x2={c} y2={d} />)}
          {[[980, 150], [1080, 210], [1200, 170], [1290, 250], [1130, 300], [1370, 190]].map(([x, y], i) => <circle key={i} cx={x} cy={y} r="2.2" stroke="none" />)}
        </g>
      </svg>
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-npst-bg" />
    </div>
  );
}
